import React from 'react';
import { observer } from "mobx-react";
import CartProductListV1 from 'ReactApp/Components/CartProductListV1/CartProductListV1';
import CartSummaryBlockV1 from 'ReactApp/Components/CartSummaryBlockV1/CartSummaryBlockV1';
import CartFormV1 from 'ReactApp/Components/CartFormV1/CartFormV1';
import { ShowableCart } from 'ReactApp/Ddd/Aggregates/ShowableCart';
import { OrderRequestStageTypeEnum, ShowableCartSourceModeEnum } from 'ReactApp/Types/enum';

type CartOrderV1Props = {
    showableCart: ShowableCart
}

const CartOrderV1 = observer((props: CartOrderV1Props) => {

    if (
        // если данные были успешно загружены
        props.showableCart.isCartDataLoaded === true
            &&
        // и пусты
        !props.showableCart.cards.length
    ) {
        return (
            <div 
                className="
                    info-block-v1 
                    box-v1 
                    box-v1_filling-type-contained 
                    box-v1_filling-color-type-gray 
                    info-block-v1_text-color-type-text
                "
                style={{
                    marginBottom: '3rem'
                }}
                >
                    <div className="info-block-v1__content">
                        <h1 className="title js-catalog-title">
                            К сожалению, Ваша корзина еще пуста!
                        </h1>
                        <p className="p-v1 p-v1_text-color-type-text" style={{
                            lineHeight: '3rem'
                        }}>
                            Предлагаем наполнить ее товарами нашего&nbsp;
                            <a href="/">интернет-магазина :)</a>
                        </p>
                    </div>
            </div>
        );
    }

    return (
        <>
            <div className="cart-page-v1__product-list-receipt-wrap">

                <div className="cart-page-v1__left">
                    <CartProductListV1 {...{
                        showableCart: props.showableCart
                    }} />
                </div>

                <div className="cart-page-v1__right">
                    <CartSummaryBlockV1 {...{
                        showableCart: props.showableCart
                    }} />
                </div>

            </div>

            {
                (
                    // изменять данные заказа можно:
                    // 1) В момент предзаказа (перед регистрацией заказа)
                    props.showableCart.sourceMode === ShowableCartSourceModeEnum.preOrder
                        ||
                    (
                        // 2) Когда заказ находится на стадии предварительной обработки
                        props.showableCart.sourceMode === ShowableCartSourceModeEnum.order
                            &&
                        props.showableCart.order.stageType === OrderRequestStageTypeEnum.registered
                    )
                ) && (
                    <CartFormV1 {...{
                        showableCart: props.showableCart
                    }} />
                )
            }


        </>
    );

})

export default CartOrderV1;